import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { IconEmail } from 'assets/icons';
import { AnimatePresence } from 'framer-motion';
import { useMailInvoice } from 'modules/invoicing/hooks';
import { Button } from 'modules/ui';
import { IMailModalProps, MailModal } from 'modules/ui/components/MailModal';
export interface IMailInvoiceAttachmentsButtonProps {
    disabled?: boolean;
    invoiceId: number;
}

export const MailInvoiceAttachmentsButton = ({ disabled, invoiceId }: IMailInvoiceAttachmentsButtonProps) => {
    const { t } = useTranslation();
    const [openModal, setOpenModal] = useState(false);

    const { attachments, recipients, handleMailInvoice, isFetching, isSending, languageCode } =
        useMailInvoice(invoiceId);

    const handleSubmit: IMailModalProps['onSubmit'] = async (data) => {
        if (isSending || !languageCode) return;
        const { success, message, rejectedEmails } = await handleMailInvoice(data);
        if (success && rejectedEmails?.length) {
            return toast.error(message);
        }
        if (success) {
            setOpenModal(false);
            return toast.success(message || t('table.actions.email.message.success'));
        }
        return toast.error(message || t('table.actions.email.message.error'));
    };

    const isButtonDisabled = disabled || isFetching || isSending;

    return (
        <>
            <AnimatePresence>
                {openModal && (
                    <MailModal
                        initialValues={{
                            attachments,
                            message: t('invoicing.sendEmailModal.message', {
                                lng: languageCode || undefined,
                            }),
                            recipients,
                        }}
                        onSubmit={handleSubmit}
                        isSubmitting={isSending}
                        title={t('invoicing.sendEmailModal.label')}
                        onOpenChange={setOpenModal}
                    />
                )}
            </AnimatePresence>
            <Button disabled={isButtonDisabled} variant="secondary" onClick={() => setOpenModal(true)}>
                <IconEmail iconBackgroundColor="#1E2124" />
                {t('common.subheader.email')}
            </Button>
        </>
    );
};
